var _defs, _circle, _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterResults = function SvgFilterResults(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filtra",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.46 91.46",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#7b8fb5;stroke-miterlimit:10;stroke-width:4px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.73,
    cy: 45.73,
    r: 42.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.2,69.28l9.22,3.91c.13.05.27-.04.27-.18l-.1-18.08s0-.07.03-.1l16.47-28.37c.07-.13-.02-.29-.17-.29H24.55c-.15,0-.24.16-.17.29l16.38,28.37s.03.06.03.09l.3,14.18c0,.08.05.14.12.17Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.36,
    y1: 34.07,
    x2: 61.72,
    y2: 34.07
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "filter_results.3bc9f0ec325345d4ce5cf9ac1fce6ec7.svg";